<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<div class=" ">
  <div class="mb-10 gap-10 flex justify-end">
    <div class="pt-20">Role View:</div>
    <div class="container radio-button radio-bg" style="margin:0px">
      <input (click)="rowViewChange(2)" [(ngModel)]="roleView" id="internal" name="roleView" type="radio" [value]="2"
        ng-control="options" />
        <label class="gray-300 click-white" for="internal">Internal</label>
      </div>
      <div class="container radio-button radio-bg" style="margin:0px">
        <input (click)="rowViewChange(1)" id="external" [(ngModel)]="roleView" name="roleView" type="radio" [value]="1"
          ng-control="options" />
          <label class="gray-300 click-white" for="external">External</label>
        </div>
      </div>
    </div>

    <!-- <div class="mt3 float-right">
    <div class="form-check form-check-inline">
      <label>Role View:</label>
    </div>
    <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio" name="roleView" ng-control="options" (click)="rowViewChange(2)"
        id="internal" value="2" checked />
        <label class="form-check-label" [ngClass]="{ 'gray-background': roleViewValue == 1 }"
        for="internal">Internal</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input" type="radio" name="roleView" [checked]="'true'" ng-control="options"
          (click)="rowViewChange(1)" id="external" value="1" />
          <label class="form-check-label" [ngClass]="{ 'gray-background': roleViewValue == 2 }"
          for="external">Extemal</label>
        </div>
      </div> -->

      <div class="">
        <table class="table-ode">
          <thead>
            <tr>
              <th>
                <div class="top-color"> </div>
                Compare detail permissions by role
              </th>
              @for (entitlementroles of rolegroupEntitlement; track entitlementroles) {
                <th>
                  <div class="top-color"> </div>
                  @for (role of entitlementroles.roles; track role) {
                    <div class="mb-5 mt-10 flex">
                      @if (role?.hasRole == 'Y') {
                        <i class="fa fa-check-circle mr-2 font-orange">
                        </i>
                      }
                      @if (role?.hasRole == 'N') {
                        <i class="fa fa-minus-circle mr-2 font-gray-600">
                        </i>
                      }
            <div class="pl-5" [ngClass]="{
                'font-orange': role?.hasRole == 'Y',
                'font-black regular': role?.hasRole == 'N'
              }">
                        {{ role?.roleName }}
                      </div>
                    </div>
                  }
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (tableRows of entitlementColumns; track tableRows; let i = $index) {
              <tr>
                <td class="font-18">{{ tableRows.entitlementName }}</td>
                @for (roleGroup of rolegroupEntitlement; track roleGroup; let j = $index) {
                  <td>
                    <div>
                      @for (entitlement of roleGroup.entitlements; track entitlement; let k = $index) {
                        <div>
                          @if (i === k) {
                            <div class="text-center">
                              @if (entitlement.hasEntitlement == 'Y') {
                                <span class="color-green font-24">
                                  <i class="fa fa-check-circle mr-5"></i>Yes</span>
                                }
                                @if (entitlement.hasEntitlement == 'N') {
                                  <span class="color-red font-24">
                                    <i class="fa fa-times-circle mr-5"></i> No</span>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <!-- <table class="table mt3">
          <thead class="card_arm">
            <tr>
              <th>Compare detail permissions by role</th>
              <th *ngFor="let entitlementroles of rolegroupEntitlement">
                <div *ngFor="let role of entitlementroles.roles">
                  <i class="fa fa-check-circle mr-2 color-light-red" *ngIf="role?.hasRole == 'Y'">
                  </i>
                  <i class="fa fa-minus-circle mr-2 color-grey" *ngIf="role?.hasRole == 'N'">
                  </i>
            <span [ngClass]="{
                'color-light-red': role?.hasRole == 'Y',
                'color-grey': role?.hasRole == 'N'
              }">{{ role?.roleName }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let tableRows of entitlementColumns; let i = index">
              <td>{{ tableRows.entitlementName }}</td>

              <td *ngFor="let roleGroup of rolegroupEntitlement; let j = index">
                <span>
                  <div *ngFor="let entitlement of roleGroup.entitlements; let k = index">
                    <div *ngIf="i === k">
                      <span *ngIf="entitlement.hasEntitlement == 'Y'" class="color-green">
                        <i class="fa fa-check-circle mr-2"></i>Yes</span>
                        <span *ngIf="entitlement.hasEntitlement == 'N'" class="color-red">
                          <i class="fa fa-times-circle mr-2"></i> No</span>
                        </div>
                      </div>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table> -->
